export default function SolucoesPerso() {
  return (
    <section className="bg-[url(../assets/cover-solucoes-perso.png)] bg-cover bg-no-repeat bg-center text-white bg-[#060316] relative overflow-hidden">
      {/* Blur effect */}
      <div
        className="absolute inset-0 blur-3xl w-[80%] mx-auto left-0 right-0 mt-16 rounded-full opacity-80"
        style={{ backgroundColor: "#000" }}
      />
      
      <div className="container mx-auto xl:max-w-6xl py-32 space-y-28 relative z-10">
        <header className="text-center">
          <h2 className="text-6xl">
            <span className="bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] text-transparent bg-clip-text">
              Soluções personalizadas
            </span>{' '}
            para <br /> potencializar a eficiência e ampliar os <br />
            resultados do seu negócio.
          </h2>
        </header>
        <main className="flex gap-8 px-4 backdrop-blur-[50px] rounded-[10px] border border-white">
          <div className="text-center flex flex-col items-center py-8">
            <h3 className="text-2xl font-medium mb-4">
              Soluções de Alta Qualidade:
            </h3>
            <p className="text-gray-300 max-w-xs">
              Arquiteturas robustas e escaláveis que suportam o crescimento e a
              evolução do negócio.
            </p>
          </div>

          <div className="h-36 w-px bg-[#C4C4C4] my-auto" />

          <div className="text-center flex flex-col items-center py-8">
            <h3 className="text-2xl font-medium mb-4">
              Melhoria de Qualidade:
            </h3>
            <p className="text-gray-300 max-w-xs">
              Aumento significativo no desempenho e eficiência operacional.
            </p>
          </div>

          <div className="h-36 w-px bg-[#C4C4C4] my-auto" />

          <div className="text-center flex flex-col items-center py-8">
            <h3 className="text-2xl font-medium mb-4">
              Segurança Fortalecida:
            </h3>
            <p className="text-gray-300 max-w-xs">
              Soluções seguras que protegem dados sensíveis e garantem a
              continuidade dos negócios.
            </p>
          </div>

          <div className="h-36 w-px bg-[#C4C4C4] my-auto" />

          <div className="text-center flex flex-col items-center py-8">
            <h3 className="text-2xl font-medium mb-4">
              Alinhamento Estratégico:
            </h3>
            <p className="text-gray-300 max-w-xs">
              Soluções que estão alinhadas com os objetivos estratégicos de
              negócios, proporcionando vantagem competitiva.
            </p>
          </div>
        </main>
      </div>
    </section>
  )
}
